import React, { FC } from 'react'
import { Select } from 'out-game/components'
import { NodeOption } from 'out-game/components/Select/base'
import { DEFAULT_LANGUAGE } from 'out-game/root/constants'
import { Currency, isCurrency, Language } from 'out-game/root/types'
import { useTranslationStrict, useLanguage } from 'out-game/hooks'
import { SelectProps } from './types'
import useSelectStyles from './useSelectStyles'

const currencyOptionsRu: ReadonlyArray<NodeOption> = [
  {
    id: 0,
    label: 'RUB (Российский Рубль)',
    value: Currency.rub,
  },
]

const currencyOptionsEn: ReadonlyArray<NodeOption> = [
  {
    id: 1,
    label: 'USD (US Dollar)',
    value: Currency.usd,
  },
  {
    id: 2,
    label: 'EUR (Euro)',
    value: Currency.eur,
  },
]

const CurrencySelect: FC<SelectProps<Currency>> = React.memo(
  ({ value, onChange }) => {
    const language = useLanguage() || DEFAULT_LANGUAGE
    const { t } = useTranslationStrict()

    const classes = useSelectStyles()

    const handleCurrencyChange = (value: unknown) => {
      if (isCurrency(value)) {
        onChange(value)
      }
    }

    return (
      <Select
        name="currency"
        value={value}
        className={classes.menuSelect}
        label={`${t('currency')}:`}
        options={
          language === Language.rus ? currencyOptionsRu : currencyOptionsEn
        }
        onChange={handleCurrencyChange}
      />
    )
  }
)

export default CurrencySelect
